import { Typography } from '@mui/material';
import { formatDate } from '@side/pantry';
import { formatDistanceToNowStrict } from 'date-fns';
import { EmptyTableCell } from '@/components/EmptyTableCell';

type Props = {
  date: string | null;
  includeDistance?: boolean;
};

export function ReferralDate({ date, includeDistance = false }: Props) {
  if (!date) return <EmptyTableCell />;

  const formattedDate = formatDate(date, 'shortDate');

  if (!includeDistance) {
    return <Typography variant="body2">{formattedDate}</Typography>;
  }

  const distance = formatDistanceToNowStrict(new Date(date), { unit: 'month' });

  return (
    <Typography variant="body2">{`${formattedDate} (${distance})`}</Typography>
  );
}
